import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import Amount from "@/models/Shared/Amount";

export default class UpdateUserRequest extends BaseUpdateRequest{
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    phone: string = '';
    enabled: boolean = false;
    paymentOrderApprovalLimit: Amount = new Amount();
    paymentOrderApprovalNotificationLowerLimit: Amount = new Amount();
}